import type { OsasQuestionnaireName } from '../../common/enums/OsasQuestionnaireName';
import type { IOSASQuestionnaire } from '../components/pages/OSAS/NewOsasQuestionnaires';

export function getIsOsasQuestionnaireComplete(name: OsasQuestionnaireName, questionnaires?: IOSASQuestionnaire[]) {
    if (questionnaires) {
        const osasQuestionnaire = questionnaires.find((questionnaire) => questionnaire.name === name);
        if (osasQuestionnaire) {
            const answers = osasQuestionnaire.answer;

            return Object.values(answers).every((value) => value !== null);
        }
    }

    return false;
}
